'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MessagesContainer = require('./MessagesContainer');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MessagesContainer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }